module.exports = __webpack_public_path__ + "static/media/logoImage.67ec2ef1.JPG";